"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

var _react = _interopRequireWildcard(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ramda = require("ramda");

var _StyledSettingsComponents = require("./StyledSettingsComponents");

var _Row = _interopRequireDefault(require("./Row"));

var _AnchorsEditableContext = _interopRequireDefault(require("../context/AnchorsEditableContext"));

var _CurrentContext = _interopRequireDefault(require("../context/CurrentContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    margin-right: 10px;\n    margin-bottom: 15px;\n    cursor: pointer;\n    transition: all .3s;\n    &:hover {\n        color: black;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var TypeIcon = (0, _styledComponents.default)(_reactFontawesome.FontAwesomeIcon)(_templateObject());

var AnchorPanel =
/*#__PURE__*/
function (_Component) {
  _inherits(AnchorPanel, _Component);

  function AnchorPanel() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AnchorPanel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AnchorPanel)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.onChangeAnchorType = function (onChangeProp, anchors, index) {
      var bezier = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      onChangeProp('anchors', (0, _ramda.assocPath)([index, 'bezier'], bezier, anchors));
    };

    _this.disableBezier = function (anchors, index) {
      return index === 0 || index === anchors.length - 1 || (0, _ramda.path)([index - 1, 'bezier'], anchors) && (0, _ramda.path)([index + 1, 'bezier'], anchors) || (0, _ramda.path)([index - 1, 'bezier'], anchors) && (0, _ramda.path)([index - 2, 'bezier'], anchors) || (0, _ramda.path)([index + 1, 'bezier'], anchors) && (0, _ramda.path)([index + 2, 'bezier'], anchors);
    };

    _this.renderPanel = function (currentAnchor, onRemoveCurrentAnchor, current, onChangeProp) {
      var anchor = current.anchors[currentAnchor.index];

      var disableBezier = _this.disableBezier(current.anchors, currentAnchor.index);

      return _react.default.createElement(_StyledSettingsComponents.Panel, null, _react.default.createElement(_Row.default, {
        label: "\u0422\u0438\u043F"
      }, !disableBezier && _react.default.createElement(TypeIcon, {
        icon: _freeSolidSvgIcons.faBezierCurve,
        color: anchor.bezier ? 'black' : 'rgb(181, 181, 181)',
        onClick: function onClick() {
          return _this.onChangeAnchorType(onChangeProp, current.anchors, currentAnchor.index, true);
        }
      }), _react.default.createElement(TypeIcon, {
        icon: _freeSolidSvgIcons.faVectorSquare,
        color: !anchor.bezier ? 'black' : 'rgb(181, 181, 181)',
        onClick: function onClick() {
          return _this.onChangeAnchorType(onChangeProp, current.anchors, currentAnchor.index);
        }
      })), _react.default.createElement(_StyledSettingsComponents.PanelButton, {
        onClick: onRemoveCurrentAnchor
      }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043E\u043F\u043E\u0440\u043D\u0443\u044E \u0442\u043E\u0447\u043A\u0443"));
    };

    return _this;
  }

  _createClass(AnchorPanel, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement(_AnchorsEditableContext.default.Consumer, null, function (_ref) {
        var currentAnchor = _ref.currentAnchor,
            onRemoveCurrentAnchor = _ref.onRemoveCurrentAnchor;
        return _react.default.createElement(_CurrentContext.default.Consumer, null, function (_ref2) {
          var current = _ref2.current,
              onChangeProp = _ref2.onChangeProp;
          return currentAnchor && _this2.renderPanel(currentAnchor, onRemoveCurrentAnchor, current, onChangeProp);
        });
      });
    }
  }]);

  return AnchorPanel;
}(_react.Component);

exports.default = AnchorPanel;